import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=f915536e&scoped=true&"
import script from "./CookieAlert.vue?vue&type=script&lang=js&"
export * from "./CookieAlert.vue?vue&type=script&lang=js&"
import style0 from "./CookieAlert.vue?vue&type=style&index=0&id=f915536e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f915536e",
  null
  
)

export default component.exports